import { Popup, formatDate, setOptions } from '@mobiscroll/react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, Button, Card, Grid, Tooltip } from "@mui/material";
import { DropDownList, } from '@progress/kendo-react-dropdowns';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import ChassisTrailerBl from '../../../../shared/common-utilities/Trailer/ChassisTailerBl.jsx';
import ChassisTrailer from '../../../../shared/common-utilities/Trailer/ChassisTrailer.jsx';
import { CommonConst as Consts } from '../../../../shared/common-utilities/enums/CommonConst.jsx';
import { PlanFunctionsForFlag as PlanFlag } from '../../../../shared/common-utilities/enums/PlanFunctionsEnum.jsx';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService.jsx';
import { chassisPlanning, driverPlanning, fetchSavedView, planGroupResources, planGroups, plannedActions, postSavedView, trailerPlanning, variousPlanning, vehiclePlanning } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts.jsx';
import getSetDataService from '../../../../shared/common-utilities/services/getSetDataService.jsx';
import IconTruck from '../../../../shared/common-utilities/utils/IconTruck.jsx';
import IconTruckWh from '../../../../shared/common-utilities/utils/IconTruckWh.jsx';
import TrailerBlIcon from '../../../../shared/common-utilities/utils/TrailerBlIcon.jsx';
import TrailerIcon from '../../../../shared/common-utilities/utils/TrailerIcon.jsx';
import VariousResourceBlIcon from '../../../../shared/common-utilities/utils/VariousResourceBlIcon.jsx';
import VariousResourceIcon from '../../../../shared/common-utilities/utils/VariousResourceIcon.jsx';
import CustomAgendaTooltip from '../../common/Agenda/CustomAgendaTooltip';
import { EventCalender } from '../../common/Agenda/EventCalender.jsx';
import Spinner from '../../common/Spinner/Spinner.jsx';
import WindowComponent from '../../common/Window/WindowComponent.jsx';
import ZoomInOut from './ZoomInOut.jsx';
import { refreshRouteAndPT } from '../../../../shared/ReduxStore/Reducers/partialTripReducer.jsx';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService.jsx';

let storage = dataStorageService();
setOptions({
    theme: 'ios',
    themeVariant: 'light'
});

let apiService = commonApiService();
const odataApiName = "agendaView";
let service = getSetDataService();

function AgendaView(props) {
    var tommorow = new Date();
    tommorow.setDate(tommorow.getDate() + 1)

    const [myEvents, setMyEvents] = useState([]);
    const [plannedAction, setPlannedAction] = useState([]);
    const [eventData, setEventData] = useState([])
    const [myResources, setMyResources] = useState([])
    const [myColors, setMyColors] = useState([
        {
            resource: "v1",
            start: '00:00',
            end: '24:00',
            recurring: {
                repeat: 'daily',
            },
            cssClass: 'md-rect-bg orange-bg',
        }
    ])
    const [tooltipAnchor, setTooltipAnchor] = useState(null);
    const [isTooltipOpen, setTooltipOpen] = useState(false);
    const closeTooltip = useRef(true);
    const [currentEvent, setCurrentEvent] = useState(null);
    const [startDate, setStartDate] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(new Date('2026-02-25T00:00:00')); //'2015-04-13T03:24:00'
    const [days, setDays] = useState(3);
    const [showWeekNumber, setShowWeekNumber] = useState(false);
    const [showCurrentTimeline, setCurrentTimeline] = useState(true);
    const [showVerticleLine, setShowVerticleLine] = useState(true);
    // const [iconActive, setIconSelected] = useState(Consts.VEHICLES);
    const iconActive = useRef(Consts.VEHICLES);
    const [isLoading,setIsLoading] = useState(false)
    const [zoomVal, setZoomVal] = useState(1)
    const [myResourcesNew, setMyResourcesNew] = useState([])
    const [resourceGrp, setResourceGrp] = useState([])
    const [selectedGrpData, setSelectedGrpData] = useState({})
    const [dialogData, setDialogData] = useState({open:false,component:<></>})
    const dialogRef = useRef(null);
    const [viewType,setViewType] = useState(Consts.Route);
    const [initialSaveViewData,setInitialSaveViewData] = useState([]);
    const [initialFetchReadLinkData,setInitialFetchReadLinkData] = useState([]);
    const [changedResource,setChangedResource] = useState(null)

    const refTime = useSelector(state => state.refreshTime.refreshTime);
    const resourceChange = useSelector(state => state?.partialTrip.agendaResource)
    const partialTripReducerData = useSelector(state => state?.partialTrip)
    const dispatch = useDispatch();

    const timerRef = useRef(null);
    const planGroup = useRef(null)
    const shouldRefresh = useRef(false)
    const selectedDateRef = useRef(selectedDate);

    let timeLineView = {
        type: 'day',
        size: days,
        resolutionHorizontal: 'hour',
        eventHeight: 'variable',
        // eventList: true,
        startTime: '00:00',
        endTime: '24:00',
        timeCellStep: 60 ,
        timeLabelStep: 60 ,
        weekNumbers: showWeekNumber,
        currentTimeIndicator: showCurrentTimeline,
        virtualScroll: true,
        resolution: 'day',     
        // maxEventStack: 5
    };
    const [myView, setMyView] = useState({
        timeline: timeLineView,
    });
    const prtFilterComponents = [
        { type: 'DateTimePicker', key: 'selectedDate', value: selectedDate, label: '', placeholder: 'Selected Date & Time' },
        { type: 'NumericTextBox', key: 'daysToShow', value: days, label: 'Days to Show', placeholder: 'Please enter value' },
        { type: 'Switch', key: 'showWeekNumber', value: showWeekNumber, label: 'Show Week', placeholder: 'Show Week' },
        { type: 'Switch', key: 'showCurrentTimeline', value: showCurrentTimeline, label: 'Show Current Timeline', placeholder: 'Show Current Timeline' },
        { type: 'Switch', key: 'showVerticleLine', value: showVerticleLine, label: 'Show Time Lines', placeholder: 'Show Time Lines' },
        { type: 'DropDownList', key: 'viewType', value: viewType, label: 'Selection', placeholder: 'Selection' },
    ];
    const planRelatedAction = [Consts.SendToOBC,Consts.ExchangeTrailer,Consts.SplitTrailer,Consts.InsertShippingLine,Consts.InsertBeginEndAction,Consts.TransferGoods,Consts.SplitTrip,Consts.MoveToLU,Consts.EmailTripSheet,Consts.PrintTripSheet,Consts.PrintCMR,Consts.ViewECMR,Consts.CreateECMR,Consts.PrintOutsourceConfirmation,Consts.EmailOutsourceConfirmation,Consts.Report,Consts.Regroup,Consts.PartialtripCard,Consts.TripCard,Consts.ShipmentCard,Consts.ResourceCard,Consts.FileCard,Consts.ShowOBCMessages,Consts.ShowResourceCard,Consts.Calculate,PlanFlag.InsertExtraAction,PlanFlag.Fixed,PlanFlag.ContractOut,PlanFlag.SendMessageToOBC,Consts.ManualMode,PlanFlag.DeletePartialTrip,PlanFlag.RemoveFromCurrentResource,PlanFlag.RemoveFromAllResources,PlanFlag.ChangeSequence,
        // Uncomment below to add functionality
        // PlanFlag.BatchTripCreation
        // PlanFlag.TruckAppointmentNew,
        // PlanFlag.TruckAppointmentOverview,
        // PlanFlag.TruckAppointmentAddTo,
    ];
    const routeIdAction = [PlanFlag.Fixed]
    const eventCard = [Consts.PartialtripCard,Consts.TripCard,Consts.ShipmentCard,Consts.ResourceCard,Consts.FileCard];
    const resourceAction = [Consts.ShowResourceCard,Consts.ShowOBCMessages,PlanFlag.SendMessageToOBC]
    const agendaAction = [Consts.Remark,Consts.AgendaItem];
    const removeAction = [PlanFlag.DeletePartialTrip,PlanFlag.RemoveFromCurrentResource,PlanFlag.RemoveFromAllResources]
    const remarksAction = [PlanFlag.ShowDetailsActionItemRemark,PlanFlag.SendToBack,PlanFlag.DeleteSelection]
    const dataRelatedAction = [PlanFlag.Refresh];

    const initialSavedViewObj = { [odataApiName]: service.initialViewsObj }

    const categories = [Consts.PartialTrip,Consts.Route,Consts.Movement];
    const userID = localStorage.getItem('userID');

    const toDayDate = new Date();
    const minDate = new Date(toDayDate.getFullYear() - 50, toDayDate.getMonth(), toDayDate.getDate());
    const maxDate = new Date(toDayDate.getFullYear() + 50, toDayDate.getMonth(), toDayDate.getDate());

    const findResourceById = (id) => {
        for (const category of myResources) {
            for (const resource of category.children) {
                if (resource.id === id) {
                    return resource;
                }
            }
        }
        return null; // If resource with the given ID is not found
    };
    const handleEventHoverIn = (args, popupType, resourceData) => {
        const event = args.event || args;
        event.popupType = popupType

        if(event?.isDummyEvent || event?.isExtraDummyEvent) 
            return
        if(event.popupType == "TruckHover")
            event.width = 350
        else if(event.popupType == "LicenseHover")
            event.width = 500
        else if(event.isAgendaItem || event.isRemark)
            event.width = 400
        else if(event.isoutOfTimeEvent)
            event.width = 200
        else
            event.width = 550

        if (!resourceData)
            event.resourceData = findResourceById(event.resource)
        else
            event.resourceData = resourceData
        setCurrentEvent(event);
        setTooltipAnchor(args?.target || args?.domEvent?.target);
        closeTooltip.current = true
        setTooltipOpen(prev => true);
    }
    const handleEventHoverOut = useCallback(() => {
        if(closeTooltip.current){
            timerRef.current = setTimeout(() => {
                setTooltipOpen(false);
            }, 50);
        }
    }, []);
    const onMouseEnter = useCallback(() => {
        if (timerRef.current) {
            closeTooltip.current = false
            clearTimeout(timerRef.current);
        }
    }, []);
    const onMouseLeave = useCallback(() => {
        timerRef.current = setTimeout(() => {
            closeTooltip.current = true
            setTooltipOpen(false);
        }, 200);
    }, []);
    const onCustomBtnClick = (value) => {
        if(iconActive.current != value) {
            iconActive.current = value
            const resourceData = myResourcesNew.filter((item)=>item.resourceType === value)
            setResourceGrp(resourceData)
            setSelectedGrpData({code:resourceData[0].code})
            planGroup.current = resourceData[0].code
        }
    }
    const callPlanningAPI = (value,isAutoRefresh = false) =>{        
        if (value === Consts.VEHICLES) {
            getEventData(vehiclePlanning, Consts.vehicleId,isAutoRefresh);
            updateTimelineResourceColWidth(190);
        } else if (value === Consts.TRAILERS) {
            getEventData(trailerPlanning, Consts.trailerId,isAutoRefresh);
            updateTimelineResourceColWidth(260);
        } else if (value === Consts.DRIVERS) {
            getEventData(driverPlanning, Consts.driverId,isAutoRefresh);
            updateTimelineResourceColWidth(260);
        } else if (value === Consts.CHASSIS) {
            getEventData(chassisPlanning, Consts.chassisId,isAutoRefresh);
            updateTimelineResourceColWidth(260);
        } else if (value === Consts.CONTAINERS) {
            // Assuming no getEventData call here, as per original code
            updateTimelineResourceColWidth(260);
        } else if (value === Consts.VARIOUS) {
            getEventData(variousPlanning, Consts.variousResourceId,isAutoRefresh);
            updateTimelineResourceColWidth(260);
        }
        getPlannedAction(value)
    }
    const updateTimelineResourceColWidth = (width) => {
        document.querySelectorAll('.mbsc-timeline-resource-col').forEach(item => {
            item.style.cssText = `${item.style.cssText} width: ${width}px !important; min-width: ${width}px !important`;
        });
    };
    const onZoomChange = useCallback((value) => {
        setZoomVal(value);
    }, []);
    const onResourceGrpChange = (e) => {
        setMyEvents([])
        setEventData([])
        setSelectedGrpData({code:e.value.code})
        planGroup.current = e.value.code;
    }
    const CustomButtons = (prop) => {
        return (
            <>
                <div className='my-buttons' style={{ position: 'absolute', display: 'flex', gap: 2, left: 0, zIndex: 10, top: '3px', paddingLeft: '0' }}>
                    {
                       [...new Set(myResourcesNew.map(item => item.resourceType))].map((item,index)=>(
                            <Tooltip title={item} key={index}>
                                {
                                    item === Consts.VEHICLES ? (
                                        <Button variant={iconActive.current === Consts.VEHICLES ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }} onClick={(e) => { onCustomBtnClick(Consts.VEHICLES); }}>
                                            {iconActive.current === Consts.VEHICLES ? <IconTruckWh /> : <IconTruck />}
                                        </Button>
                                    ) :  item === Consts.TRAILERS ? (
                                        <Button variant={iconActive.current === Consts.TRAILERS ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }} onClick={(e) => { onCustomBtnClick(Consts.TRAILERS); }}>
                                            {iconActive.current === Consts.TRAILERS ? <TrailerIcon /> : <TrailerBlIcon />}
                                        </Button>
                                    ) : item === Consts.DRIVERS ? (
                                        <Button variant={iconActive.current === Consts.DRIVERS ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }} onClick={(e) => { onCustomBtnClick(Consts.DRIVERS); }}>
                                            {iconActive.current === Consts.DRIVERS ? <AccountCircleIcon sx={{ color: 'white' }} /> : <AccountCircleIcon color="primary" />}
                                        </Button>
                                    // ) : item === Consts.CONTAINERS ? (
                                    //     <Button variant={iconActive.current === Consts.CONTAINERS ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }} onClick={(e) => { onCustomBtnClick(Consts.CONTAINERS); }}>
                                    //         {iconActive.current === Consts.CONTAINERS ? <ContainerIconWh /> : <ContainerIcon />}
                                    //     </Button>
                                    ) : item === Consts.VARIOUS ?  (
                                        <Button variant={iconActive.current ===  Consts.VARIOUS ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }}  onClick={(e) => { onCustomBtnClick( Consts.VARIOUS); }} >
                                            {iconActive.current ===  Consts.VARIOUS ? <VariousResourceIcon/> : <VariousResourceBlIcon />}
                                        </Button>
                                    ) : item === Consts.CHASSIS ? (
                                        <Button variant={iconActive.current === Consts.CHASSIS ? 'contained' : 'outlined'} size="small" sx={{ px: .0, minWidth: '34px', minHeight: '32px' }} onClick={(e) => { onCustomBtnClick(Consts.CHASSIS); }}>
                                            {iconActive.current === Consts.CHASSIS ? <ChassisTrailerBl width={25} height={15}/> : <ChassisTrailer width={25} height={15}/>}
                                        </Button>
                                    ) : (
                                        <></>
                                    )
                                }
                            </Tooltip>
                        ))
                    }
                </div>
                <div className='slider-top' style={{ position: 'absolute', display: 'flex', gap: 2, right: '10px', zIndex: 10, bottom: '-6px', paddingLeft: '0' }}>
                    <Button disabled={zoomVal == 1 ? true : false} onClick={()=>onZoomChange(zoomVal - 1)}>
                        <RemoveIcon/>
                    </Button>
                    <ZoomInOut step={1} zoomVal={zoomVal} min={1} max={5} onZoomChange={onZoomChange}/>
                    <Button disabled={zoomVal == 5 ? true : false} onClick={()=>onZoomChange(zoomVal + 1)}>
                        <AddIcon/>
                    </Button>
                </div>
                {
                    !isLoading && (
                        <div  style={{ position: 'absolute', display: 'flex', gap: 2, left: 5, zIndex: 10, top: '45px', width:'180px', paddingLeft: '0' }}>
                            <DropDownList
                                style={{
                                    width: "100%",
                                }}
                                disabled={resourceGrp.length > 1 ? false :true}
                                value={selectedGrpData}
                                data={resourceGrp}
                                dataItemKey="code"
                                textField="code"
                                onChange={onResourceGrpChange}
                            />
                        </div>
                    )
                }
            </>
        )
    }     
    const findAndUpdateResource = (arr, id, depth) => {
        for (const item of arr) {
            if (item.id === id && depth === 0) {
                item.eventCreation = item.eventCreation == false ? true : false
                if (!item.eventCreation) {
                    myColors.push({
                        resource: id,
                        start: '00:00',
                        end: '24:00',
                        recurring: {
                            repeat: 'daily',
                        },
                        cssClass: 'md-rect-bg',
                    })
                    setMyColors([...myColors])
                } else {
                    setMyColors([...service.removeCssClass(myColors, item.id, 'md-rect-bg')])
                }
                return true; // Return true if element is found and updated
            }
            else if (item.children && depth > 0) {
                const found = findAndUpdateResource(item.children, id, depth - 1);
                if (found) return true;
            }
        }
        setMyResources([...arr])
        return false;
    };
    const onWheel = (e) => {
        e.stopPropagation()
        if (e.deltaY < 0) {
            myView.timeline.timeCellStep -= 30
            myView.timeline.timeLabelStep -= 30
            setMyView({ ...myView })
        }
        else if (e.deltaY > 0) {
            if (myView.timeline.timeCellStep <= 240) {
                myView.timeline.timeCellStep += 30
                myView.timeline.timeLabelStep += 30
            } else if (myView.timeline.type == 'week') {
                myView.timeline.type = 'month'
                myView.timeline.startDay = 0
                myView.timeline.endDay = 6
            }
            setMyView({ ...myView })
        }
    }
    const handleSelectedDate = (value) => {
        const date = new Date(value?.value);
        if (date == 'Invalid Date' || date < minDate || date > maxDate) return;
        setSelectedDate(date);
        selectedDateRef.current = date
    };
    const updateTimeLineView = (key, value, property) => {
        timeLineView[property] = value;
        setMyView({ timeline: { ...timeLineView } });
    };
    const toggleProperty = (property, setState, stateValue) => {
        timeLineView[property] = !stateValue;
        setState(!stateValue);
        setMyView({ timeline: { ...timeLineView } });
    };
    const onChange = (key, value) => {
        switch (key) {
            case 'selectedDate':
                handleSelectedDate(value);
                break;
            case 'daysToShow':
                if (value.value) {
                    updateTimeLineView(key, value.value, 'size');
                    setDays(value.value);
                }
                break;
            case 'showWeekNumber':
                toggleProperty('weekNumbers', setShowWeekNumber, showWeekNumber);
                break;
            case 'showCurrentTimeline':
                toggleProperty('currentTimeIndicator', setCurrentTimeline, showCurrentTimeline);
                break;
            case 'showVerticleLine':
                if (!showVerticleLine) {
                    service.showTimelines()
                } else {
                    service.removeTimelines()
                }
                setShowVerticleLine(!showVerticleLine);
                break;
            case 'viewType' :
                setViewType(value)
                break;
            default:
                break;
        }
        
    };    
    const renderCustomDay = useCallback((args) => {
        const date = args.date;
        return (
            <div className="header-template-container">
                <div className="header-template-date">
                    <div className="header-template-day">{formatDate('DD-MM-YYYY', date)}</div>
                </div>
            </div>
        );
    }, []);
    const getPlanGroupData = (isAutoRefresh = false)=>{
        let expands = `$filter=planGroup eq '${selectedGrpData.code}'`;
        if(resourceGrp[0].resourceType == Consts.VEHICLES){
            expands+="&$expand=vehicles($expand=resourceQualifications)"
        }else if (resourceGrp[0].resourceType == Consts.TRAILERS || resourceGrp[0].resourceType == Consts.CHASSIS){
            expands+="&$expand=trailers($expand=resourceQualifications)"
        }else if (resourceGrp[0].resourceType == Consts.DRIVERS){
            expands+="&$expand=drivers($expand=resourceQualifications)"
        }else if (resourceGrp[0].resourceType == Consts.VARIOUS){
            expands+="&$expand=variousResources($expand=resourceQualifications($select=description,typeQualification))"
        }
        apiService.get(planGroupResources, null,expands).then((response) => {     
            if(response?.value.length > 0) {
                setMyResources(service.transformResourceData(response.value))
            } else {
                if(!isAutoRefresh){  
                    setIsLoading(false)
                }
            }
        })
    }
    const getResourceData = (isAutoRefresh = false) => {
        if(!isAutoRefresh)
            setIsLoading(true)
        // let expands = '$expand=planGroupResources($orderby=subgroup,planGroupOrder)';
        apiService.get(planGroups, null,'').then((response) => {     
            if(response?.value.length > 0) {
                setMyResourcesNew(response?.value);
                const resourceData = response?.value.filter((item)=>item.resourceType === iconActive.current)
                // setMyResources(service.transformResourceData(resourceData[0].planGroupResources))
                
                setResourceGrp(resourceData)
                if(!isAutoRefresh){  
                    setSelectedGrpData({code:resourceData[0].code})
                    planGroup.current = resourceData[0].code
                    setIsLoading(false)
                }
            } else {
                if(!isAutoRefresh){  
                    setIsLoading(false)
                }
            }
        })   
    }
    const parseEventResponse = (data,oldKey, newKey) => {
        return data?.map(item => {
            const startTime = new Date(`${item.startingDate}T${item.startingTime}`)
            let endTime = new Date(startTime.getTime());
            const [hours, minutesFraction] = item?.actionDurationHM == 0 ? "1".toString().split('.') :item?.actionDurationHM.toString().split('.');
            const hoursToAdd = parseInt(hours, 10);
            const minutesToAdd = parseInt(minutesFraction ? minutesFraction : 0, 10);
            endTime.setHours(endTime.getHours() + hoursToAdd);
            endTime.setMinutes(endTime.getMinutes() + minutesToAdd);
            let newFields = {start:startTime,end:endTime,id:item.routeId}
            if(item?.fixedActionTime){
                newFields.editable = false
                // newFields.resize = false
                // newFields.dragInTime = false
                // newFields.dragBetweenResources = false
            }
            item = service.replaceKey(item, oldKey, newKey,newFields)            
            return item;
        });    
    }
    const getEventData = (eventUrl,key,isAutoRefresh=false) => {
        if(!isAutoRefresh)
            setIsLoading(true)  
        const startDate = selectedDateRef.current
        const endDate = new Date(startDate).setDate(startDate.getDate()+days)     
        let filter = `$filter=(ptEndingDate ge ${moment(startDate).format("yyyy-MM-DD")} and ptStartingDate lt ${moment(endDate).format("yyyy-MM-DD")} and planGroupCode eq '${planGroup.current}') and emptyTrip eq false`

        apiService.get(eventUrl,filter).then((response)=>{
            let newEvents = parseEventResponse(response?.value,key,Consts.resource)
            // setTimeout(()=>{
                setEventData(newEvents)
            // },500)
            if(!isAutoRefresh)
                setIsLoading(false)
        })
    }
    const getPlannedAction = (resourceType,isAutoRefresh=false,newEventData = []) => {
        const startDate = selectedDateRef.current
        const newStartDate = moment(startDate, "ddd MMM DD YYYY HH:mm:ss ZZ");
        newStartDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        const formatedStartDate = newStartDate.format('YYYY-MM-DDTHH:mm:ss[Z]');

        const endDate = newStartDate
        const newEndDate = moment(endDate);
        newEndDate.add(days, 'days');
        const formatedEndDate = newEndDate.format('YYYY-MM-DDTHH:mm:ss[Z]');

        let filter = `$filter=(resourceTypeNvt eq '${resourceType}' and fromDateTime ge ${formatedStartDate} and toDateTime lt ${formatedEndDate}) and (sourceType eq ${Consts.isRemark} or sourceType eq ${Consts.isAgendaItem})`;
        apiService.get(plannedActions,filter).then((response)=>{
            if(response?.value){
            // Added timeout so first eventData can update
            setTimeout(()=>{
                setPlannedAction(service.parseActionResponse(response?.value))
            },500)
        }
            
        })
    } 
    const onDialogClose = (e) => {        
        if(e && dialogRef.current) {
            const data = dialogRef.current.getDialogData();
            if(dialogData.key == Consts.moveToSubGroupDialog)            
                changePlanSubgroup(data)
        }
        setDialogData({open:false,component:<></>});  
    }
    const changePlanSubgroup = ({params,selectedSubGroup})=>{
        if(selectedSubGroup && params.selectedResource.subgroup != selectedSubGroup?.name){
            if(params.selectedResource.subgroup == "")
                params.selectedResource.subgroup = Consts.Default
            const oldSubGroup = params.resources.findIndex(e => e.name == params.selectedResource.subgroup)
            const newSubGroup = params.resources.findIndex(e => e.name == selectedSubGroup?.name)            
            params.selectedResource.subgroup = myResources[newSubGroup].name
            myResources[newSubGroup]?.children.push(params.selectedResource)
            myResources[oldSubGroup].children = myResources[oldSubGroup]?.children.filter(r => r.id != params.selectedResource.id)
            if(myResources[oldSubGroup].children.length == 0)
                myResources.splice(oldSubGroup,1)
            setMyResources([...myResources])
        }
    }
    const fetchSavedViews = async() => {
        const ptUrl = `${fetchSavedView}?$filter=(title eq '${odataApiName}' and userID eq '${userID}')`;
        apiService.get(ptUrl).then(async(savedViewRes) => {
            if (savedViewRes?.value?.length > 0) {
                apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then(readResPT => {
                    if (readResPT !== undefined && readResPT !== null && readResPT !== '' ) {
                        setInitialSaveViewData(savedViewRes.value);
                        setInitialFetchReadLinkData(readResPT);
                    }
                    localStorage.setItem(odataApiName + 'Savedview', JSON.stringify(readResPT && readResPT !== '' ? readResPT :initialSavedViewObj));
                })
            } else {
                return await apiService.post(postSavedView,{ userID: userID, title: odataApiName }).then(response => {
                    return response;
                })
            }
        })
    } 
    const childStateHandler = (value, flag) => {
        if (flag === 'refresh') {
            if (iconActive.current == Consts.VEHICLES) {
                getEventData(vehiclePlanning, Consts.vehicleId);
            } else if (iconActive.current == Consts.TRAILERS)  {
                getEventData(trailerPlanning, Consts.trailerId);
            } else if (iconActive.current == Consts.DRIVERS) {
                getEventData(driverPlanning,Consts.driverId)
            } else if (iconActive.current == Consts.CHASSIS) {
                getEventData(chassisPlanning,Consts.chassisId)
            } else if (iconActive.current == Consts.CONTAINERS) {
                console.log("Container planning API is pending")
                // getEventData(vehiclePlanning,"vehicleId")
            } else if (iconActive.current == Consts.VARIOUS) {
                getEventData(variousPlanning,Consts.variousResourceId)
            }
        } else if (flag == Consts.fixed) {
            let newEventData = []
            if(viewType == Consts.Route) {
                newEventData = myEvents.filter(e => !e.isAgendaItem && !e.isRemark).map(item => 
                    item?.routeId == value ? {
                         ...item, fixedActionTime : !item?.fixedActionTime 
                    } : item
                )                
                setEventData(newEventData)
            } else {
                const index =  myEvents.findIndex(p => p.partialTripId == value)
                if(index != -1){                    
                    newEventData = myEvents.map(item => 
                        item?.partialTripId == value ? {
                             ...item, fixedActionTime : !item?.fixedActionTime 
                        } : item
                    )
                    let newEventDataTrp = eventData.map(item => 
                        item?.partialTripId == value ? {
                             ...item, fixedActionTime : newEventData[index].fixedActionTime
                        } : item
                    )
                    setEventData(newEventDataTrp)
                }                
            }
            setMyEvents(newEventData)
        } else if(flag == 'manualRefresh') {
            callPlanningAPI(iconActive.current)
            if(window.location.hash.includes("#/CustomView")) {
                dispatch(refreshRouteAndPT({ isRefreshRouteAndPT: !partialTripReducerData.isRefreshRouteAndPT }))
            }
        } else if (flag == 'refreshAction') {
            getPlannedAction(iconActive.current)
        }
    }
    const onShortcutKeyPress = (event) => {
        if (event.altKey && event.key === '+') {
            if(zoomVal < 5)
			    onZoomChange(zoomVal+1)
		}
        if (event.altKey && event.key === '-') {
            if(zoomVal > 1)
			    onZoomChange(zoomVal-1)
		}
	}
    useEffect(() => {
		document.addEventListener('keydown', onShortcutKeyPress);
		// Remove event listener when the component unmounts
		return () => {
		  document.removeEventListener('keydown', onShortcutKeyPress);
		};
	}, [onShortcutKeyPress])
    useEffect(() => {
        const createCustomViewRoute = window.location.hash.includes("#/CreateCustomView");
        if (selectedGrpData?.code != null && selectedGrpData?.code !== 'undefined') {            
            if(!createCustomViewRoute){
                callPlanningAPI(iconActive.current); 
                getPlanGroupData()
            }
            if (!showVerticleLine) {
                service.removeTimelines();
            }
        }
    }, [selectedDate, iconActive.current,selectedGrpData,showVerticleLine]);
    useEffect(()=>{        
        if (refTime && refTime !="null" && refTime !="undefined") {
            const fetchData = () => {
                if (shouldRefresh.current) {
                    callPlanningAPI(iconActive.current, true);
                } else {
                    shouldRefresh.current = true
                }
            };
            const intervalId = setInterval(fetchData, refTime * 1000);      
            return () => clearInterval(intervalId);
        }
    },[refTime])
    useEffect(()=>{
        if(!showVerticleLine)
            service.removeTimelines()
    },[myView])
    useEffect(() => {          
        // Remove bellow code for release
        let userMail = storage.getLocalStorageData('userMail')
        if((userMail == 'b.panchal@navitrans.eu' || userMail == 'h.rana@navitrans.eu' || userMail == 'm.joshi@navitrans.eu'))
            handleSelectedDate({value:new Date('2025-05-01T00:00:00')})
        else if(userMail == 'b.trivedi@navitrans.eu')
            handleSelectedDate({value:new Date('2025-06-01T00:00:00')})
        else if(userMail == 'k.shah@navitrans.eu')
            handleSelectedDate({value:new Date('2025-04-01T00:00:00')})
        getResourceData()
        fetchSavedViews()
        if(!showVerticleLine)
            service.removeTimelines()  
    }, [])
    useEffect(() => {
        let value = zoomVal;
        if (parseInt(value) === 1) value = 1;
        else if (parseInt(value) === 2) value = 2;
        else if (parseInt(value) === 3) value = 4;
        else if (parseInt(value) === 4) value = 8;
        else if (parseInt(value) === 5) value = 24;
    
        setMyView((prevVal) => ({
          ...prevVal,
          timeline: {
            ...prevVal.timeline,
            timeCellStep: 60 * parseInt(value),
            timeLabelStep: 60 * parseInt(value),
            resolutionHorizontal: parseInt(value) === 24 ? 'day' : 'hour'
          }
        }));
    }, [zoomVal]);
    useEffect(() => {
        if (!_.isEmpty(resourceChange)) {
            setChangedResource(resourceChange)
        }
    }, [resourceChange])
    useEffect(() => {
        if (changedResource != null && window.location.hash.includes("#/CustomView")) {
          callPlanningAPI(iconActive.current, true);
        }
    }, [changedResource]);

    return (
        <>
            {isLoading ? <Spinner /> : (<></>)}
            <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }}>
                <Box sx={{ p: 0, display: 'flex', }} className="filterbar-bg ">
                    <EventCalender
                        {...props}
                        myResourcesNew={myResourcesNew}
                        myView={myView}
                        resourceGrp={resourceGrp}
                        selectedDate={selectedDate}
                        timeFormat='HH:mm'
                        startDate={startDate}                            
                        myColors={myColors}
                        renderCustomDay={renderCustomDay}
                        myResources={myResources}
                        handleEventHoverIn={handleEventHoverIn}
                        handleEventHoverOut={handleEventHoverOut}
                        autoFocus={true}
                        onSelectedDateChange={(e)=>{handleSelectedDate({value:e.date})}}
                        CustomButtons={()=> <CustomButtons sx={{ p: 1, }} />}
                        planRelatedAction={planRelatedAction}
                        eventCard={eventCard}
                        resourceAction={resourceAction}
                        agendaAction={agendaAction}
                        remarksAction={remarksAction}
                        routeIdAction={routeIdAction}
                        removeAction={removeAction}
                        dataRelatedAction={dataRelatedAction}
                        initialSaveViewData={initialSaveViewData}
                        entity={odataApiName}
                        gridFlagVal={odataApiName}
                        initialFetchReadLinkData={initialFetchReadLinkData}
                        sendDataToParent={childStateHandler}
                        iconActive={iconActive.current}
                        prtFilterComponents={prtFilterComponents}
                        minDate={minDate}
                        maxDate={maxDate}
                        days={days}
                        categories={categories}
                        viewType={viewType}
                        onChange={onChange}
                        eventData={eventData}
                        plannedAction={plannedAction}
                        setTooltipOpen={setTooltipOpen}
                    />
                    <Popup
                        display="anchored"
                        isOpen={isTooltipOpen}
                        anchor={tooltipAnchor}
                        touchUi={false}
                        showOverlay={false}
                        contentPadding={false}
                        closeOnOverlayClick={false}
                        //width={400}
                        width={currentEvent?.width || 550}
                        cssClass="md-tooltip"
                    >
                        <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                            <CustomAgendaTooltip currentEvent={currentEvent} iconActive={iconActive.current} noOfAction={_.size(_.filter(eventData, { partialTripId: currentEvent?.partialTripId }))} />
                        </div>
                    </Popup>
                    {dialogData.open && <>
                        <WindowComponent title={dialogData.title} visible={dialogData.open} initialWidth={dialogData.iWidth} initialHeight={dialogData.iHeight} minWidth={dialogData.minWidth} minHeight={dialogData.minHeight} onClose={(e)=>{onDialogClose(false)}} dataComponent={dialogData.component} params={dialogData?.params} actionButtons={dialogData.actionButtons}  doubleClickStageChange={false} minimizeButton={() => null } maximizeButton={() => null} />
                    </>}
                </Box>
            </Grid>
        </>
    );
}

export default AgendaView;